// extracted by mini-css-extract-plugin
export default {"content-wrapper":"deficiency-service_content-wrapper__l6Eqh","recommendations":"deficiency-service_recommendations__XlggP"};